export default function(emailFieldToValidateAgainst,element){
    
    const originalFieldValidates = this.form[emailFieldToValidateAgainst].validates
    const originalFieldValue = this.form[emailFieldToValidateAgainst].value
    const identicalInputs = (element.value === originalFieldValue)


    return (identicalInputs && originalFieldValidates)
}